import { useState } from "react";
import { useApp } from '../../../context/AppContext';
import { Link, useParams, useNavigate } from "react-router-dom";

//import locales
import { useTranslation } from "react-i18next";
import "../../../i18n";

//import components
import AuthModal from "./AuthModal";
import RegisterModal from './RegisterModal';
import ResetModal from './ResetModal';

//import resources
import { RiLogoutCircleLine, RiUser2Line } from "react-icons/ri";




export default function Auth () {

    //import context
    const { user, logout } = useApp();

    //import navigate
    const navigate = useNavigate();

    //get locale
    const { locale } = useParams();
    const { t } = useTranslation();
    
    //modal state
    const [showModal, setShowModal] = useState({
        auth: false,
        register: false,
        reset: false
    });

    //show modal
    const handleClick = (type) => {
        setShowModal({
            auth: false,
            register: false,
            reset: false,
            [type]: true
        });
    }


    //logout
    const handleLogout = () => {
        logout();
        navigate(`/${locale}`)
    }


    return (
        
        <>
            {
                typeof user === 'object' && user != null ? 
                    <>
                        <Link to={`/${locale}/profile`} className="w-fit xl:w-full flex items-center rounded-3xl border border-gray-300 justify-center px-4 lg:px-5 h-[50px] right-0 me-2 top-0 mt-[3px] text-black relative text-[14px]">
                            <div className="hidden xl:block"><span className="hidden 2xl:inline-block">{t("welcome")}:</span> {user?.user?.fname}</div>
                            <div className="block xl:hidden"><RiUser2Line /></div>
                        </Link> 
                        <button onClick={() => handleLogout() } className="flex items-center rounded-3xl bg-red-100 px-4 lg:px-5 h-[50px] right-0 me-2 top-0 mt-[3px] text-red-900 text-[20px] relative font-bold">
                            <RiLogoutCircleLine />
                        </button>
                    </>
                : 
                <>
                    <button className="rounded-3xl w-fit xl:w-full border border-[var(--orange)] px-4 lg:px-5 h-[50px] right-0 me-2 top-0 mt-[3px] text-black" onClick={()=>handleClick('auth')}><span className="hidden md:block">{t("login")}</span><span className="block md:hidden"><RiUser2Line /></span></button>
                </>
            }
            
            
            { showModal.auth && <AuthModal handleClick={handleClick} /> }

            { showModal.register && <RegisterModal handleClick={handleClick} /> }

            { showModal.reset && <ResetModal handleClick={handleClick} /> }

            
            
        </>
    );
}